import { useEffect } from 'react'

import { useInterview } from '@/react-query/interview/interview'
import { useReadyTitleBlinking } from '@/views/hooks/useReadyTitleBlinking'

export const useWaitForTranscriptGeneration = () => {
  const interview = useInterview()

  const { startReadyTitleBlinking } = useReadyTitleBlinking()

  useEffect(() => {
    if (!interview?.data?.isFullTranscriptGenerating) {
      return
    }

    console.log('Start waiting for transcript generation')
    const interval = window.setInterval(async () => {
      if (!interview?.data) {
        if (interval !== null) {
          clearInterval(interval)
        }
        return
      }
      const newInterview = await interview.refetch()
      if (newInterview.data?.isFullTranscriptGenerating === false) {
        console.log('Transcript generation finished', {
          newInterview,
        })
        if (interval !== null) {
          clearInterval(interval)
        }

        console.log('Transcript generation finished')

        startReadyTitleBlinking()
      }
    }, 5000)
    return () => {
      if (interval !== null) {
        clearInterval(interval)
      }
    }
  }, [interview.data?.isFullTranscriptGenerating])
}
